import produce from 'immer';
import { SHOW_ERROR_STATUS, HIDE_ERROR_STATUS } from '../../actions/actionTypes';

export const defaultState = {
    code: false,
    message: '',
    retryAction: '',
};

const errorStatus = produce((draft, action) => {
    switch (action.type) {
        case SHOW_ERROR_STATUS:
            return {
                ...draft,
                code: action.errorCode,
                message: action.errorMessage,
                retryAction: action.retryAction,
            };
        case HIDE_ERROR_STATUS:
            return {
                ...draft,
                code: defaultState.code,
                message: defaultState.message,
                retryAction: defaultState.retryAction,
            };
    }
}, defaultState);

export default errorStatus;
